import { WORKER_REQUEST, CREATE_WORKER, GET_WORKERS, UPDATE_WORKER, DELETE_WORKER, WORKER_REQUEST_FAILURE, KARIGAR_WORKER_REQUEST, GET_KARIGAR_WORKERS, KARIGAR_WORKER_REQUEST_FAILURE } from '../types';

const initialState = {
  workers: [],
  karigarWorkers: [],
  loading: false,
  error: null,
};

const workerReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKER_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case KARIGAR_WORKER_REQUEST: {
      return {
        ...state,
        karigarWorkers: [],
        loading: true,
        error: null
      }
    }
    case GET_WORKERS: {
      return {
        ...state,
        workers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_KARIGAR_WORKERS: {
      return {
        ...state,
        karigarWorkers: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_WORKER:
      return {
        ...state,
        workers: [action.payload, ...state.workers],
        loading: false,
        error: null
      };
    case UPDATE_WORKER:
      const workersData = state.workers.slice(0);
      const uIndex = workersData.findIndex((data) => data.id === action.payload.id);
      workersData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        workers: [ ...workersData ],
        loading: false,
        error: null
      };
    case DELETE_WORKER:
      const workers = state.workers?.slice(0);
      const index = workers.findIndex((data) => data.id === action.id);
      if (index > -1) {
        workers.splice(index, 1);
      }
      return {
        ...state,
        workers: [...workers],
        loading: false,
        error: null
      }
    case WORKER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    case KARIGAR_WORKER_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default workerReducer;
